import calculatePagerPageNumber from "../calculatePagerPageNumber/calculatePagerPageNumber";

const correctOutOfBoundsPageSelection = (
  currentPageSizeAsNumber: number,
  totalItems: number,
  pagination: {
    page: number;
    pageSize: unknown;
  },
  setPagination: (pagination: { page: number; pageSize: unknown }) => void
) => {
  const amountOfExistingPages = calculatePagerPageNumber(totalItems, currentPageSizeAsNumber);

  if (amountOfExistingPages > 0 && pagination.page >= amountOfExistingPages) {
    setPagination({
      ...pagination,
      page: amountOfExistingPages - 1,
    });
  }
};

export default correctOutOfBoundsPageSelection;
